import React from 'react';

const ComponentHeaderDescriptions = ({ description }) => {
    return (
        <div class="component-header-descriptions">
        {description}
    </div>
    );
}

export default ComponentHeaderDescriptions;